import { BASEAPIGESTTORAUTH } from '../api/gesttor'
import { npsAtendimentoCadastrarPayload} from "../../interfaces/npsAtendimento"

export function npsAtendimento (idTarefa: string, payload: npsAtendimentoCadastrarPayload) {
    return BASEAPIGESTTORAUTH.post(`/nps/${idTarefa}`, payload)
}